module.exports = __webpack_public_path__ + "media/components/star-rating/static/yellow/6-7d343b35e6b3eb2d7f58b526805b8adf.svg";